import { useEffect } from "react";
import Lenis from "lenis";
import Grain from "./components/Grain";
import ErrorBoundary from "./components/ErrorBoundary";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Legacy from "./components/Legacy";
import Founders from "./components/Founders";
import Pillars from "./components/Pillars";
import InDevelopment from "./components/InDevelopment";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
    useEffect(() => {
        if (
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
            return;
        }
        const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="bg-ink text-cream font-sans">
            <Grain />
            <ErrorBoundary>
                <Nav />
                <main>
                    <Hero />
                    <div
                        className="site-body relative z-10 -mt-[22vh] bg-ink"
                        data-testid="site-body"
                    >
                        <Legacy />
                        <Founders />
                        <Pillars />
                        <InDevelopment />
                        <Contact />
                        <Footer />
                    </div>
                </main>
            </ErrorBoundary>
        </div>
    );
}

export default App;
